// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class LinkService {
   $http: any
   $timeout: any
   fire: any
   constructor($http: any, $timeout: any, hooksService: any) {

      this.getSources = this.getSources.bind(this)
      this.$http = $http
      this.$timeout = $timeout
      hooksService.setHooks(this, 'LinkService', ['update'], true)
   }

   getSources(doc: any)  {
      const params = {}
      const hasIssns = doc.issns && doc.issns.length
      // take the first issn/isbn in the list for now; issn takes priority
      // @ts-expect-error TS(2339) FIXME: Property 'issn' does not exist on type '{}'.
      if (hasIssns) { params.issn = doc.issns[0] }
      // @ts-expect-error TS(2339) FIXME: Property 'isbn' does not exist on type '{}'.
      if (!hasIssns && doc.isbns && doc.isbns.length) { params.isbn = doc.isbns[0] }
      if (!_.isEmpty(params)) {
         const promise = this.$http.get(`/ext/360link?${$.param(params)}`)
         return promise.then((response: any) => {
            return this.fire('update', response.data)
         }
         , () => {
            // fire update on error to remove spinner
            return this.fire('update')
         })
      } else {
      // give directive some time for to display
         return this.$timeout((() => this.fire('update')), 100)
      }
   }
}

LinkService.$inject = ['$http', '$timeout', 'hooksService']

angular.module('summonApp.services')
   .service('linkService', LinkService)
